const H2 = ({ children }) => (
  <h2 className="font-serif font-medium text-3xl sm:text-4xl leading-tight text-[#1A2522]">{children}</h2>
);
const Label = ({ children }) => (
  <p className="text-[10px] tracking-[0.28em] uppercase font-semibold text-[#374F49] mt-10 mb-4">{children}</p>
);

const Timeline = ({ items, testId }) => (
  <ol className="mt-10 border-l border-[#D3CEC4]" data-testid={testId}>
    {items.map(([when, what], i) => (
      <li key={i} className="relative pl-8 pb-7 last:pb-0">
        <span className="absolute -left-[5px] top-2 w-[9px] h-[9px] rounded-full bg-[#374F49]"></span>
        <p className="font-serif text-lg text-[#374F49]">{when}</p>
        <p className="mt-1 text-[13px] sm:text-base text-[#495854] leading-relaxed">{what}</p>
      </li>
    ))}
  </ol>
);

const Entries = ({ items, testId }) => (
  <ul className="space-y-4" data-testid={testId}>
    {items.map(([name, role], i) => (
      <li key={i} className="border-l-2 border-[#D3CEC4] pl-5">
        <p className="font-serif text-lg text-[#1A2522]">{name}</p>
        <p className="text-[13px] text-[#495854] leading-relaxed">{role}</p>
      </li>
    ))}
  </ul>
);

const Section = ({ id, title, children, tone }) => (
  <section data-testid={`about-${id}`} className={tone ? "bg-[#EAE5D9]/60 border-y border-[#D3CEC4]/60" : ""}>
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-16 sm:py-24 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
        <H2>{title}</H2>
      </div>
      <div className="lg:col-span-8">{children}</div>
    </div>
  </section>
);

export const AcademicProfile = ({ a }) => (
  <>
    <Section id="career" title={a.careerTitle} tone>
      <Timeline items={a.career} testId="career-timeline" />
    </Section>
    <Section id="awards" title={a.awardsTitle}>
      <Timeline items={a.awards} testId="awards-list" />
    </Section>
    <Section id="societies" title={a.societiesTitle} tone>
      <Label>{a.societiesSubtitle}</Label>
      <Entries items={a.societies} testId="societies-list" />
      <Label>{a.editorialSubtitle}</Label>
      <Entries items={a.editorial} testId="editorial-list" />
      <p className="mt-8 text-[13px] sm:text-base text-[#495854] leading-relaxed">{a.editorialNote}</p>
    </Section>
    <Section id="trials" title={a.trialsTitle}>
      {a.trialsIntro.map((p, i) => (
        <p key={i} className="text-[14px] sm:text-[15px] text-[#495854] leading-[1.85] font-light mb-5">{p}</p>
      ))}
      <Label>{a.trialsAreasLead}</Label>
      <Entries items={a.trialsAreas} testId="trials-areas" />
      <p className="mt-10 text-[13px] tracking-[0.14em] uppercase text-[#7A857F]" data-testid="about-orcid">
        {a.orcidLabel}:{" "}
        <a href="https://orcid.org/0000-0003-4003-5278" target="_blank" rel="noopener noreferrer" className="text-[#374F49] hover:text-[#1A2522] underline underline-offset-4">
          ORCID 0000-0003-4003-5278
        </a>
      </p>
    </Section>
  </>
);
